import { createRouter, createWebHistory } from 'vue-router'
// import MainLayout from '@/components/MainLayout'
import page1 from "@/views/page1"
import page2 from "@/views/page2"
import page3 from "@/views/page3"
import page4 from "@/views/page4"
import page5 from "@/views/page5"
import page6 from "@/views/page6"
import page7 from "@/views/page7"
import application_case from "@/views/application_case"
import AI1 from "@/views/AI1"
import AI2 from "@/views/AI2"
import AI3 from "@/views/AI3"

import load from "@/views/load"
import show_product from "@/views/show_product"
import page_api_1 from "@/views/page_api_1"

// import test from "@/views/test"



import login from "@/views/Login"


// -----------------------------

import MainLayout from '@/components/MainLayout_v2'
// import page1 from "@/views/page1_v2"


const routes = [
	{
		path: '/',
		name: 'home',
		// redirect:"/login",
		redirect: "/main",
	},

	{
		path: '/load',
		name: 'load',
		component: load
	},
	{
		path: '/main',
		name: 'MainLayout',
		component: MainLayout,
		redirect: "/main/index",
		children: [
			{
				path: 'login',
				name: 'login',
				component: login
			},
			{
				path: 'index',
				name: 'index',
				component: page1,
			},
			{
				path: 'product_center',
				name: 'product_center',
				component: page2,
			},
			{
				path: 'project_case',
				name: 'project_case',
				component: page3,
			},
			{
				path: 'page4',
				name: 'page4',
				component: page4,
			},
			{
				path: 'about_us',
				name: 'about_us',
				component: page5,
			},
			{
				path: 'contact_information',
				name: 'contact_information',
				component: page6,
			},
			{
				path: 'page_api_1',
				name: 'page_api_1',
				component: page_api_1,
			},
			{
				path: 'show_product',
				name: 'show_product',
				component: show_product,
			},
			{
				path: 'industry_applications',
				name: 'industry_applications',
				component: page7,
			},
			{
				path: 'application_case',
				name: 'application_case',
				component: application_case,
			},
			{
				path: 'AI1',
				name: 'AI1',
				component: AI1,
			},
			{
				path: 'AI2',
				name: 'AI2',
				component: AI2,
			},
			{
				path: 'AI3',
				name: 'AI3',
				component: AI3,
			},

			// {
			// 	path:'4_1',
			// 	name:'4_1',
			// 	redirect:"/main/show_product",
			// },
			// {
			// 	path:'4_2',
			// 	name:'4_2',
			// 	redirect:"/main/show_product",
			// },
			// {
			// 	path:'4_3',
			// 	name:'4_3',
			// 	redirect:"/main/show_product",
			// },
		]
	},
	// {
	// 	path: '/test',
	// 	name: 'test',
	// 	component: test
	// },

]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

export default router
